import classNames from 'classnames';

import lang from '../../../../lib/language';

import IconReset from '../../../../assets/img/icon-reset.svg';
import IconResetBlue from '../../../../assets/img/icon-reset-blue.png';
import { ClickableDiv } from '../../../../components';

import styles from './ResetDailyLossButton.module.scss';

type Props = {
  disabled: boolean;
  onClick: () => void;
};

const ResetDailyLossButton = ({ disabled, onClick }: Props) => (
  <ClickableDiv
    disabled={disabled}
    onClick={() => !disabled && onClick()}
    className={classNames(styles.resetButton, { [styles.resetButtonDisabled]: disabled })}
  >
    <>
      <img alt="" src={disabled ? IconResetBlue : IconReset} className={styles.resetIcon} />
      {lang.tradingPlanResetDailyLossBtn()}
    </>
  </ClickableDiv>
);

export default ResetDailyLossButton;
